import { gql } from "@apollo/client";

export default gql`
  mutation DataCleanMutation($tableName: String!) {
    DataClean(tableName: $tableName) {
      count
      message
      status
    }
  }
`;
